import { jsx as _jsx } from "react/jsx-runtime";
import SocialMediaLink from "../social-media-link/social-media-link";
import styles from "./social-media-link-list.module.css";
const SocialMediaLinkList = ({ links  })=>/*#__PURE__*/ _jsx("ul", {
        className: styles.list,
        children: links.map((props)=>/*#__PURE__*/ _jsx(SocialMediaLink, {
                ...props
            }, props.name))
    });
export default SocialMediaLinkList;
